<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <!-- <a-col :md="6" :sm="24">
            <a-form-item label="预测名称：">
              <global-select
                @change="handleNameChange"
                :value.sync="queryParams.forecastName"
                selectType="select"
                requestApi="/scp/fcNewProduct/forecastNamePullDown"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="预测起始月">
              <a-input disabled="true" v-model="queryParams.startMonth"/>
            </a-form-item>
          </a-col> -->
          <a-col :md="6" :sm="24">
            <a-form-item label="版本">
              <global-select
                @change="handleVersionChange"
                :value.sync="queryParams.versionCode"
                selectType="select"
                requestApi="/scp/fcNewProduct/versionCodePullDown"
                :setParams="{ scpForecastType: 'FC4',forecastName: queryParams.forecastName }"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="版本说明">
              <a-input disabled="true" v-model="queryParams.versionDescription"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="事业部">
              <global-select
                :max-tag-count="1"
                :max-tag-text-length="4"
                show-search
                :value.sync="queryParams.businessUnit"
                :dropdown-match-select-width="false"
                selectType="selectMultipleSearch"
                :selectData="businessUnitList"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              />
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="工艺大类">
                <global-select
                  :max-tag-count="1"
                  :max-tag-text-length="4"
                  show-search
                  :value.sync="queryParams.productBroadCategory"
                  :dropdown-match-select-width="false"
                  selectType="selectMultipleSearch"
                  :selectData="productBroadCategoryList"
                  :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                />
              </a-form-item>
            </a-col>
          </template>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="序列号">
                <a-input :disabled="false" v-model="queryParams.serialNum"/>
              </a-form-item>
            </a-col>
          </template>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="物料名称">
                <a-input :disabled="false" v-model="queryParams.itemName"/>
              </a-form-item>
            </a-col>
          </template>
          <template v-if="advanced">
            <a-col :md="6" :sm="24" >
              <a-form-item label="项目组">
                <a-select mode="multiple" :max-tag-count="1" show-search option-filter-prop="children" v-model="queryParams.projectTeamList" >
                  <a-select-option v-for="(item) in projectTeams" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="getTableInfo" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="handleExport" type="primary">导出</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <a-spin :spinning="isLoading">

          <ls-api-table
            ref="dataTable"
            :columns="columns"
            :tableProps="tableProps"
            rowKey="detailId"
            :scroll="{ fixScreen: true, x: 1300 }"
          >
            <span slot="operation" slot-scope="{ record,$index }">
              <a v-if="!isEdit || currentId !== record.id" @click="handleEdit(record,$index)">编辑</a>
              <a v-if="!isEdit || currentId !== record.id" class="ml10" @click="handleDelete(typeList, record)">删除</a>
              <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
              <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
            </span>
            <!-- 平均活动价 -->
            <template slot="averageActivityPrice" slot-scope="{ record }">
              <span v-if="!isEdit || currentId !== record.id">{{ record.averageActivityPrice }}</span>
              <a-input-number :min="0" v-if="isEdit && currentId === record.id" v-model="record.averageActivityPrice" size="small" />
            </template>
            <!-- 平均采购价 -->
            <template slot="averagePurchasePrice" slot-scope="{ record }">
              <span v-if="!isEdit || currentId !== record.id">{{ record.averagePurchasePrice }}</span>
              <a-input-number :min="0" v-if="isEdit && currentId === record.id" v-model="record.averagePurchasePrice" size="small" />
            </template>
            <!-- 物料编码 -->
            <template slot="itemCode" slot-scope="{ record }">
              <span v-if="!isEdit || currentId !== record.id">{{ record.itemCode }}</span>
              <a-input v-if="isEdit && currentId === record.id" v-model="record.itemCode" size="small" />
            </template>

            <!-- 月份 -->
            <template slot="month" slot-scope="{ record, column }">
              <span v-if="!isEdit || currentId !== record.id">{{ record[column.dataIndex].newForecast }}</span>
              <a-input-number
                :min="0"
                v-if="isEdit && currentId === record.id"
                v-model="record[column.dataIndex].newForecast"
                size="small"
              />
              <!-- <a-button @click="handlerTestClick(record, column)"> 测试</a-button>  @change="handleInputChange(record,column.dataIndex)"-->
            </template>

            <template slot="isStopFlag" slot-scope="{ record }">
              <span >{{ record.isStopFlag === 'Y' ? '是' : '否' }}</span>
            </template>

          <!-- <div
            v-for="item in monthColumns1"
            :slot="item.dataIndex"
            slot-scope="{record}"
            :key="item.dataIndex"
          >
            <a-input v-model="record.versionCode"></a-input>
          </div> -->
          </ls-api-table>
        </a-spin>
      </div>
    </template>
  </ls-table-layout>
</template>

  <script>
  import { apiFcNewProductDetailList, apiFcNewProductDetail, apiDelFcNewProductDetail } from '@/api/scp/new-product-forecast/new-product-forecast'
  import { generateLsTableResData } from '@/utils/util.js';
  import moment from 'moment'
  export default {
    // eslint-disable-next-line
    name: 'detail', // name要和菜单路由保存一致; 新页面不要建这种容易重复的name
    components: {

    },
    data () {
      return {
        projectTeams: [], // 项目组
        isLoading: false,
        tableList: [],
        businessUnitList: [], // 事业部
        productBroadCategoryList: [], // 工艺大类
        monthColumns1: [
          {
            title: '版本',
            width: 140,
            fixed: 'left',
            dataIndex: 'month0',
            ellipsis: true,
            align: 'center'
          },
          {
            title: '平均采购价',
            fixed: 'left',
            dataIndex: 'month1',
            scopedSlots: { customRender: 'averagePurchasePrice' },
            width: 140,
            align: 'center'
          },
          {
            title: '平均活动价',
            fixed: 'left',
            dataIndex: 'month1',
            scopedSlots: { customRender: 'averageActivityPrice' },
            width: 140,
            align: 'center'
          }
        ],
        monthColumns: [],
        isSetTitle: false,
        // 表格配置
        tableProps: {
          requestApi: generateLsTableResData(apiFcNewProductDetailList, true),
          pageCurrent: true
        },
        isEdit: false,
        currentId: "",
        // 控制搜索展开
        advanced: true,
        // 查询参数
        queryParams: {
          itemName: undefined,
          serialNum: undefined,
          productBroadCategory: undefined,
          businessUnit: undefined,
          projectTeamList: undefined,
          foldNumber: undefined,
          // 预测名称
          forecastName: undefined,
           // 版本
          versionCode: undefined,
          versionDescription: ''
        },
        // 表格多选
        selectedRowKeys: [],
        selectedRows: [],
        // 状态快码
        statusOptions: [
          {
            dictLabel: "有效",
            dictValue: "Y"
          },
          {
            dictLabel: "无效",
            dictValue: "N"
          }
        ],
        baseUomFlagOptions: [
          {
            dictLabel: "是",
            dictValue: "Y"
          },
          {
            dictLabel: "否",
            dictValue: "N"
          }
        ],
        columns: [],
        columnsServe: [],
        // 表格字段
        columnsNative: [
         {
            title: '序列号',
            fixed: 'left',
            ellipsis: true,
            dataIndex: 'serialNum',
            width: 80,
            align: 'center'
          },
          {
            title: '事业部',
            fixed: 'left',
            dataIndex: 'scpBusinessUnit',
            width: 120,
            align: 'center'
          },
          {
            title: '工艺大类',
            fixed: 'left',
            dataIndex: 'productBroadCategory',
            width: 100,
            align: 'center'
          },
          {
            title: '物料名称',
            fixed: 'left',
            ellipsis: true,
            dataIndex: 'itemName',
            scopedSlots: { customRender: 'itemName' },
            width: 120,
            align: 'center'
          },
          {
            title: '规格描述',
            width: 180,
            ellipsis: true,
            dataIndex: 'specification',
            align: 'left'
          },
          {
            title: '项目组',
            width: 180,
            ellipsis: true,
            dataIndex: 'projectTeam',
            align: 'center'
          },
          {
            title: '平均采购价',
            dataIndex: 'averagePurchasePrice',
            scopedSlots: { customRender: 'averagePurchasePrice' },
            ellipsis: true,
            width: 240,
            align: 'center'
          },
          {
            title: '平均活动价',
            dataIndex: 'averageActivityPrice',
            scopedSlots: { customRender: 'averageActivityPrice' },
            width: 100,
            align: 'center'
          },
            {
            title: '操作',
            width: 140,
            fixed: 'right',
            align: 'center',
            dataIndex: 'operation',
            scopedSlots: { customRender: 'operation' }
            }
        ],
        unitOfMeasureList: [],
        unitOfMeasureListNew: []
      }
    },
    created () {
       this.queryParams.forecastName = this.$route.params.forecastName;
       this.queryParams.versionCode = this.$route.params.versionCode;
       this.queryParams.versionDescription = this.$route.params.versionDescription;
       this.columns = this.columnsNative;
       this.forecastName = this.queryParams.forecastName;
       this.versionCode = this.queryParams.versionCode;
       this.versionDescription = this.queryParams.versionDescription;
       this.getLookupList('SCP_BUSINESS_UNIT', 'businessUnitList', 'businessUnitList')
       this.getLookupList('SCP_PRODUCT_BROAD_CATEGORY', 'productBroadCategoryList', 'productBroadCategoryList')
       this.getLookupList('SCP_PROJECT_TEAM', 'projectTeams', 'projectTeams')
    },
    mounted () {
      this.getTableInfo()
    },
    methods: {
      handleInputChange (record, dataIndex) {
        // debugger
      },
      handleDelete (tableList, record) {
        const self = this
      this.$confirm({
        title: '警告',
        content: `真的要删除该项的数据项吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          const ids = []
          self.columnsServe.forEach((column) => {
            console.log(column.indexKey)
            const id = record[column.indexKey].id
            ids.push(id)
          })
          apiDelFcNewProductDetail(record).then(response => {
            if (response.code === 200) {
              self.$message.success('删除成功')
              self.onSearch()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
      },
      handleOperation (text, record) {
        this.$router.push({ path: `/salesForecast/detail/` })
      },
      handleNameChange (val, selectList) {
        const filteredItem = selectList.filter(item => item.realValue === val);
        this.queryParams.startMonth = filteredItem[0].bringOutDataOne
      },
      handleVersionChange (val, selectList) {
        const filteredItem = selectList.filter(item => item.realValue === val);
       this.queryParams.versionDescription = filteredItem[0].bringOutDataOne
       this.versionCode = this.queryParams.versionCode;
       this.versionDescription = this.queryParams.versionDescription;
      },
      getLookupList (type, arr, code) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        this[arr] = response.rows
        if (code === 'businessUnitList') {
          this[arr] = this[arr].filter(item => item.attribute1 === null); // 只显示attribute1为""的
        }
      })
      },
      blur (record) {
        if (!record.conversionRate || Number(record.conversionRate) <= 0) {
          this.$message.warning('折换不能为空且需大于0')
        } else {
          record.conversionRateInverse = this.$countBackwards(Number(record.conversionRate))
        }
      },
      statusOnChange (record) {
        record.status = record.status === 'Y' ? 'N' : 'Y'
      },
      // 导入导出excel
      /** 导出按钮操作 */
      handleExport () {
        this.download('scp/fcNewProductDetail/export', {
          ...this.queryParams
        }, `预测缺失-${this.queryParams.versionCode}-${moment().format('YYYYMMDD')}.xlsx`)
      },
      // 编辑
      handleEdit (record, index) {
        if (this.currentId && record.id !== this.currentId && this.isEdit) {
          this.$message.warning('请保存上次编辑的数据')
          return;
        }
        this.isEdit = true;
        this.currentId = record.id;
      },
      // 编辑-保存
      handleSave (record) {
        let isNoEdit = false
        let title = ''
        for (const key in record) {
            if (key.includes('month') && (record[key].newForecast === '' || record[key].newForecast === undefined || record[key].newForecast === null)) {
              isNoEdit = true
              const foundItem = this.columnsServe.find(item => item.indexKey === key);
              title = title + foundItem.indexName + ','
          }
        }
        if (record.averageActivityPrice === '' || record.averageActivityPrice === undefined || record.averageActivityPrice === null) {
          title = title + '平均活动价,'
          isNoEdit = true
        }
        if (record.averagePurchasePrice === '' || record.averagePurchasePrice === undefined || record.averagePurchasePrice === null) {
          title = title + '平均采购价,'
          isNoEdit = true
        }
        if (isNoEdit) {
            this.$message.error(title + '列为空，保存失败')
            return
          }
      const recordCopy = JSON.parse(JSON.stringify(record))
      apiFcNewProductDetail(recordCopy).then((response) => {
        if (response.code === 200) {
          this.$message.success('更新成功')
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
      })
      },
      // 取消
      handleCancel (record) {
        this.isEdit = false
        this.onSearch()
      },
      // 新增/修改框事件
      handleOk () {
        this.onSearch()
      },
      // 表单搜索
      onSearch () {
        this.isEdit = false
        this.$refs.dataTable.searchParams = this.queryParams;
        this.$refs.dataTable.getData();
      },
      getTableInfo () {
      this.isEdit = false
      this.$refs.dataTable.searchParams = this.queryParams;
      if (this.isLoading) {
        return
      }
      this.$refs.dataTable.myPagination.current = 1
      this.isLoading = true
      apiFcNewProductDetailList({ ...this.queryParams, pageSize: this.$refs.dataTable.myPagination.pageSize, pageNum: 1 }).then((response) => {
        this.isLoading = false
        if (response.code === 200) {
          this.tableList = response.rows
          this.tableList.forEach((obj, index) => {
            obj.id = index + 1 // 生成唯一的ID，可以使用索引值加上 1
          })
          this.$refs.dataTable.myDataSource = this.tableList
          const titles = response.title
          this.columnsServe = response.title
          // 生成新的对象数组，并为每个对象添加name属性
          const newArray = titles.map((title) => {
            return {
              title: title.indexName,
              dataIndex: title.indexKey,
              scopedSlots: { customRender: 'month' },
              width: 120,
              align: 'center'
            }
          })
          const dynamicColumn = this.setNewColumn('foldNumber', this.columnsNative, newArray)
          this.columns = dynamicColumn
          this.$refs.dataTable.myPagination.total = response.total
          this.$refs.dataTable.pageTotal = this.$refs.dataTable.getPageTotal(response.total, this.$refs.dataTable.myPagination.pageSize)
        } else {
          this.tableList = []
            this.$refs.dataTable.myDataSource = this.tableList
          this.$message.error(response.msg)
        }
      }).catch((error) => {
        this.isLoading = false
        // 处理 API 调用失败的情况
        console.error('API 调用失败: ', error);
      })
    },
      /** 重置按钮操作 */
      resetQuery () {
        this.queryParams = {
          forecastName: this.forecastName,
          versionCode: this.versionCode,
          versionDescription: this.versionDescription,
          businessUnit: undefined,
          serialNumber: undefined,
          productBroadCategory: undefined,
          itemName: undefined,
          serialNum: undefined,
          projectTeamList: undefined,
          foldNumber: undefined
        }
        this.onSearch()
      },
      // 搜索框展开、收起
      toggleAdvanced () {
        this.advanced = !this.advanced
      },
          /**
     * 在table 某个列的字段后增加列
     * key：列的字段名称
     * columnList 列表的列
     * insertColumnList 插入的新列
     *  */
    setNewColumn (key, columnList, insertColumnList) {
      const newArray = [...columnList] // 创建新的数组，保持原始数据的不变
      const index = newArray.findIndex((item) => item.dataIndex === key) // 找到具有indexKey值为'kk'的对象的索引位置
      if (index !== -1) {
        newArray.splice(index + 1, 0, ...insertColumnList) // 在索引位置后面插入新数组
      }
      return newArray
    }
    }
  }
  </script>

  <style scoped lang="less">
  .ml10{
    margin-left: 10px;
  }
  </style>
